"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProcedure = void 0;
var axios_1 = __importDefault(require("axios"));
var react_router_1 = require("react-router");
var useProcedure = function () {
    var navigate = (0, react_router_1.useNavigate)();
    var location = (0, react_router_1.useLocation)();
    var initialValues = {
        name: "",
        email: "",
        checked: false,
    };
    var validateName = function (value) {
        var error;
        if (!value) {
            error = "氏名を入力してください";
        }
        return error;
    };
    var validateMail = function (value) {
        var error;
        if (!value) {
            error = "メールアドレスを入力してください";
        }
        return error;
    };
    var validateIsCheck = function (value) {
        var error;
        if (!value) {
            error = "同意が必要です";
        }
        return error;
    };
    var onSubmit = function (values, actions) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios_1.default
                            .post((_a = location.state) === null || _a === void 0 ? void 0 : _a.procedure_url, {
                            procedure_code: (_b = location.state) === null || _b === void 0 ? void 0 : _b.procedure_code,
                            email: values.email,
                            name: values.name,
                        })
                            .then(function (result) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                localStorage.setItem("token", result.data.token);
                                navigate("/main");
                                return [2 /*return*/];
                            });
                        }); })
                            .catch(function (error) {
                            if (error.response.data.error.type === "forbidden") {
                                alert("接続の有効期限が切れています。恐れ入りますが、再度認証手続きを行ってください。");
                                navigate("/");
                                return;
                            }
                            else if (error.response.data.error.type === "validate") {
                                if (error.response.data.error.details.procedure_code) {
                                    alert("認証コードの読み取りに失敗しました。恐れ入りますが、再度認証手続きを行ってください。");
                                    navigate("/");
                                    return;
                                }
                                var customError = [];
                                customError["name"] =
                                    error.response.data.error.details.name &&
                                        error.response.data.error.details.name[0];
                                customError["email"] =
                                    error.response.data.error.details.email &&
                                        error.response.data.error.details.email[0];
                                actions.setErrors(customError);
                                return;
                            }
                            return;
                        })];
                case 1:
                    _c.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _c.sent();
                    return [2 /*return*/];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return {
        initialValues: initialValues,
        validateName: validateName,
        validateMail: validateMail,
        validateIsCheck: validateIsCheck,
        onSubmit: onSubmit,
    };
};
exports.useProcedure = useProcedure;
